import React from "react";
import { getFormattedDate, normalizeId } from "../helpers/utility";

const TextInput = ({
  id,
  title,
  onChange,
  onFormChange,
  value,
  preValue,
  className = "",
  textArea = false,
  hint = "",
  required = false,
  variant = "text",
  onClick,
  disabled = false,
  options = [],
  style = { fontSize: "10px" },
}) => {
  let defaultValue = value || preValue;
  if (variant === "date" && defaultValue) {
    const date = new Date(defaultValue);
    defaultValue = getFormattedDate(date);
  }
  const inputID = id || normalizeId(title);
  return (
    <>
      <input
        id={inputID}
        type={variant}
        onChange={(e) => {
          if (onChange) onChange(e);
          if (onFormChange) onFormChange(e);
        }}
        defaultValue={defaultValue}
        className={"form-control " + className}
        as={textArea ? "textarea" : "input"}
        placeholder={hint}
        required={required}
        onClick={onClick}
        disabled={disabled}
        list={`${inputID}-list`}
        style={{ ...style }}
      />
      <datalist id={`${inputID}-list`}>
        {options.map((option) => (
          <option value={option} />
        ))}
      </datalist>
    </>
  );
};

export default TextInput;
